import Select from './select';

const mapToOptions = (list: string[]) => list.map((name) => ({ name, value: name }));

export default function NewItkLocationFilters({
    country,
    region,
    city,
    countries,
    regions,
    cities,
    setCountry,
    setRegion,
    setCity,
}: {
    country: string;
    region: string;
    city: string;
    countries: string[];
    regions: string[];
    cities: string[];
    setCountry: (v: string) => void;
    setRegion: (v: string) => void;
    setCity: (v: string) => void;
}) {
    return (
        <div className="filters partners-select marketnavigator-filters">
            <div className="filter-item">
                <Select
                    name="Страна"
                    value={country}
                    options={mapToOptions(countries)}
                    onChange={(v) => setCountry(v || '')}
                />
            </div>
            <div className="filter-item">
                <Select
                    name="Регион"
                    value={region}
                    options={mapToOptions(regions)}
                    onChange={(v) => setRegion(v || '')}
                />
            </div>
            <div className="filter-item">
                <Select
                    name="Населенный пункт"
                    value={city}
                    options={mapToOptions(cities)}
                    onChange={(v) => setCity(v || '')}
                />
            </div>
        </div>
    );
}
